function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: 'TabPane',
  inject: ['tabRoot'],
  isTabPane: true,
  props: {
    name: {
      type: String,
      required: true
    },
    tab: String,
    disabled: Boolean,
    closable: Boolean
  },
  data: function data() {
    return {};
  },
  computed: {
    rootPrefixCls: function rootPrefixCls() {
      return this.tabRoot.prefixCls;
    },
    activeName: function activeName() {
      return this.tabRoot.activeName;
    },
    destroyInactiveTabPane: function destroyInactiveTabPane() {
      return this.tabRoot.destroyInactiveTabPane;
    },
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-tabpane");
    },
    normalizeName: function normalizeName() {
      var name = this.name;
      return name;
    },
    isActive: function isActive() {
      var activeName = this.activeName,
          normalizeName = this.normalizeName;
      return normalizeName && activeName === normalizeName;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          isActive = this.isActive;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-inactive"), !isActive), _defineProperty(_ref, "".concat(prefixCls, "-active"), isActive), _ref;
    }
  },
  created: function created() {
    this.addToRoot();
  },
  updated: function updated() {
    this.tabRoot.$emit('tab-update');
  },
  beforeDestroy: function beforeDestroy() {
    this.removeFromRoot();
  },
  methods: {
    addToRoot: function addToRoot() {
      this.tabRoot.addDescendant(this);
    },
    removeFromRoot: function removeFromRoot() {
      this.tabRoot.removeDescendant(this);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes,
    attrs: {
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "tabPane.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);